import { createActionCreator, createReducer } from 'deox';
import { AppState } from 'types/AppState';
import { TemplateListItem, TemplateState } from 'types/templateTypes';
import { produce, Draft } from 'immer';
import { projectPersistKeys } from 'constants/persist';
import { Licenses } from 'types/Licenses';

export const importTemplateAction = createActionCreator(
  'TEMPLATE/IMPORT',
  resolve => (id: string) => resolve(id)
);

export const applyTemplate = createActionCreator(
  'TEMPLATE/APPLY_TEMPLATE',
  resolve => (template: Partial<AppState>) => resolve(template)
);

export const updateTemplateList = createActionCreator(
  'TEMPLATE/UPDATE_LIST',
  resolve => (list: TemplateListItem[]) => resolve(list)
);

export const updateExportProgress = createActionCreator(
  'TEMPLATE/EXPORT_PROGRESS',
  resolve => (progress: number) => resolve(progress)
);
export const setCurrentTemplateId = createActionCreator(
  'TEMPLATE/SET_CURRENT_TEMPLATES_ID',
  resolve => (id: string) => resolve(id)
);

export const template = createReducer(
  { list: [], exportProgress: 0, templateScenes: [] },
  handle => [
    handle(
      updateTemplateList,
      produce<(d: Draft<TemplateState>, a: ReturnType<typeof updateTemplateList>) => void>(
        (draft, { payload }) => {
          draft = Object.assign(draft, { list: payload });
        }
      )
    ),
    handle(updateExportProgress, (state, { payload }) => ({ ...state, exportProgress: payload })),
    handle(setCurrentTemplateId, (state, { payload }) => ({ ...state, currentTemplateId: payload }))
  ]
);

export const getExportProgress = (state: AppState): number => state.template.exportProgress;

export const getTemplateList = (state: AppState): TemplateListItem[] => state.template.list;

export const getProjectTemplate = (state: AppState): Partial<AppState> => {
  const project: any = {};
  projectPersistKeys.forEach(key => (project[key] = state[key]));
  return project;
};

export const isTemplateUsed = (state: AppState): boolean => {
  return state.scenes.items.some(
    scene => scene.license && scene.license === Licenses.TemplatePremium
  );
};

export const getCurrentTemplateId = (state: AppState) => state.template.currentTemplateId;
